package nl.appstuff.padelchecker.site.directory

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import nl.appstuff.padelchecker.site.SiteColors
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text

@Composable
fun DirectoryContentBox(content: @Composable () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier { property("flex", "1") }
            .background(SiteColors.backgroundLight)
            .padding(topBottom = 64.px, leftRight = 24.px),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().maxWidth(960.px),
            verticalArrangement = Arrangement.spacedBy(24.px),
        ) {
            content()
        }
    }
}

@Composable
fun DirectoryHeading(text: String) {
    SpanText(
        text,
        modifier = Modifier
            .fontSize(40.px)
            .lineHeight(1.15)
            .fontWeight(FontWeight.Bold)
            .color(SiteColors.textLight),
    )
}

@Composable
fun DirectorySubheading(text: String) {
    SpanText(
        text,
        modifier = Modifier
            .fontSize(24.px)
            .fontWeight(FontWeight.SemiBold)
            .color(SiteColors.textLight)
            .padding(top = 16.px),
    )
}

@Composable
fun DirectoryParagraph(text: String) {
    SpanText(
        text,
        modifier = Modifier
            .fontSize(16.px)
            .lineHeight(1.65)
            .color(SiteColors.textMutedLight),
    )
}

@Composable
fun DirectoryLink(href: String, label: String) {
    val isExternal = href.startsWith("http://") || href.startsWith("https://")
    if (isExternal) {
        A(href = href, attrs = {
            attr("rel", "noopener")
            attr("target", "_blank")
            style {
                color(rgb(0x1A, 0x73, 0xE8))
                property("text-decoration", "none")
                fontSize(16.px)
                property("line-height", "1.7")
            }
        }) {
            Text(label)
        }
    } else {
        Link(
            path = href,
            variant = UncoloredLinkVariant,
            modifier = Modifier
                .color(rgb(0x1A, 0x73, 0xE8))
                .fontSize(16.px)
                .textDecorationLine(TextDecorationLine.None)
                .styleModifier { property("line-height", "1.7") },
        ) {
            SpanText(label)
        }
    }
}

@Composable
fun DirectoryGrid(content: @Composable () -> Unit) {
    Column(verticalArrangement = Arrangement.spacedBy(8.px)) { content() }
}
